import { motion, useReducedMotion } from "framer-motion";

const lines = ["Once, a message took three", "weeks to arrive. People", "still said everything."];

export const Hero = () => {
    const reduce = useReducedMotion();
    return (
        <section className="relative flex min-h-[100svh] flex-col justify-center px-6 md:px-10">
            <span
                aria-hidden="true"
                className="pointer-events-none absolute left-1/2 top-1/2 -z-10 -translate-x-1/2 -translate-y-1/2 select-none font-deva text-[42vw] leading-none text-ink opacity-[0.025]"
            >
                पत्र
            </span>

            <h1 className="mx-auto w-full max-w-5xl font-serif text-[2.5rem] leading-[1.08] tracking-tight sm:text-6xl md:text-[4.4rem] md:leading-[1.06]">
                {lines.map((l, i) => (
                    <span key={i} className="block overflow-hidden pb-[0.14em]">
                        <motion.span
                            className="block"
                            initial={reduce ? false : { y: "115%" }}
                            animate={{ y: "0%" }}
                            transition={{ duration: 1.15, delay: 0.15 + i * 0.16, ease: [0.19, 1, 0.22, 1] }}
                        >
                            {l}
                        </motion.span>
                    </span>
                ))}
            </h1>

            <motion.div
                initial={{ opacity: 0, y: 10 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 1.15, duration: 1 }}
                className="mx-auto mt-12 flex w-full max-w-5xl items-center gap-4"
            >
                <span className="font-deva text-2xl text-wax">पत्र</span>
                <span className="h-px w-8 bg-rule" />
                <span className="font-sans text-[0.7rem] tracking-[0.34em] uppercase text-sepia">patra · letter</span>
            </motion.div>

            <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ delay: 1.7, duration: 1.2 }}
                className="absolute bottom-10 left-1/2 -translate-x-1/2 flex flex-col items-center gap-3"
            >
                <span className="font-sans text-[0.62rem] tracking-[0.34em] uppercase text-sepia">scroll</span>
                <span className="relative h-12 w-px overflow-hidden bg-rule">
                    <motion.span
                        className="absolute inset-x-0 top-0 h-1/2 bg-wax"
                        animate={reduce ? {} : { y: ["-100%", "200%"] }}
                        transition={{ duration: 2.2, repeat: Infinity, ease: "easeInOut" }}
                    />
                </span>
            </motion.div>
        </section>
    );
};
